export class DbConnectionConfig {
    className = "";
    database = "";
    catalog = "";
    windowsAuth = false;
    connectionString = "";
}
